import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import { StyledDropDown } from './styles/DropDown.styles';

const DropDownControl = ({ control, renderMode }) => (
  <ObjectWrapper>
    <StyledDropDown styleProps={control.attributes} renderMode={renderMode} height={control.height}>
      {control.displayValue}
    </StyledDropDown>
  </ObjectWrapper>
);

export default DropDownControl;